import React from "react"
import PageLayout from "../../../components/PageLayout"
import { Link } from "react-router-dom"
const VerificationSuccess = () => {
    const pageName = "Verification success"

    const breadcrumbItems = [
        { text: "Home", link: "/" },
        { text: pageName, link: "/verification/success" },

    ];
    return (
        <React.Fragment>
            <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems} >
                <div className='payment-verify-layout'>
                    <span className="title">Verification Successfull</span>
                    <span className="sub-text">Great news!Your payment method verification went smoothly.To return to the home page and proceed with the next steps please click the button below.</span>
                    <Link to={'/dashboard'}>
                        <button className="button-background">Back to home</button>
                    </Link>
                </div>
            </PageLayout>
        </React.Fragment >)
}
export default VerificationSuccess